// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".author[data-v-dd040560]{align-items:center;display:flex}.author__content[data-v-dd040560]{padding-left:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
